export const ColorfulDivider = () => (
    <span className="flex h-[2px] w-full items-start">
        <div className="w-1/5 border-t-2 border-primary-green"></div>
        <div className="w-1/5 border-t-2 border-primary-pink"></div>
        <div className="w-1/5 border-t-2 border-primary-orange"></div>
        <div className="w-1/5 border-t-2 border-primary-yellow"></div>
        <div className="w-1/5 border-t-2 border-primary-violet"></div>
    </span>
);
